export const spinner = {
  label: 'Verifying',
};
